export const AUTHENTICATION_REQUIRED_ERROR = 'authentication_required';

export type AuthenticationRequiredResponse = {
  error: typeof AUTHENTICATION_REQUIRED_ERROR;
  message: string;
  redirect_url: string;
};

function isAuthenticationRequiredResponse(
  value: unknown
): value is AuthenticationRequiredResponse {
  if (!value || typeof value !== 'object') return false;

  const response = value as Partial<AuthenticationRequiredResponse>;
  return (
    response.error === AUTHENTICATION_REQUIRED_ERROR &&
    typeof response.message === 'string' &&
    typeof response.redirect_url === 'string' &&
    response.redirect_url.length > 0
  );
}

export function recoverAuthentication(
  response: Response,
  payload: unknown,
  target: Pick<Window, 'location'> = window
): boolean {
  if (response.status !== 401 || !isAuthenticationRequiredResponse(payload)) {
    return false;
  }

  target.location.replace(payload.redirect_url);
  return true;
}
